import type { ModalState } from '@/shared/ui/AppModal/model/types/appModal';

export const LAWYER_MODAL_NAMES = [
  'dateTime',
  'consultation',
  'confirmation',
  'callback',
  'complaint',
  'success',
  'image',
] as const satisfies ReadonlyArray<keyof ModalState>;

export type LawyerModalName = (typeof LAWYER_MODAL_NAMES)[number];
